import React from "react"
import Link from "gatsby-link"
import { FormattedMessage } from "react-intl"

import formatPagePath from "../utils/format-page-path"

export interface TopnavProps {
  items: { key: string; path: string }[]
  dark?: boolean
}

const Topnav: React.FC<TopnavProps> = props => {
  const isDark = !!props.dark

  return (
    <nav
      id="menu-topnav"
      className={`c-topnav o-wrapper o-row ${isDark ? "-dark" : ""}`}
    >
      {props.items.map(item => {
        return (
          <Link
            key={item.key}
            to={formatPagePath(item.path)}
            className="c-topnav__item"
            activeClassName="active"
          >
            <FormattedMessage id={"navigation." + item.key} />
          </Link>
        )
      })}
    </nav>
  )
}

export default Topnav
